import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import footerdata from '../../data/footerdata.json';
import classnames from "classnames";
import connect from "react-redux/es/connect/connect";
import {actionSubscribeForm} from "../../actions/authAction";
import btnLoader from "../../assets/img/button-loader.svg";


class Footer_v1 extends Component {
    constructor(props) {
        super(props);
        window.scrollTo(0,0);
        this.state={
            name:'',
            email:'',
            errors:{}
        }
    }





    componentDidMount() {
        let publicUrl = process.env.PUBLIC_URL+'/';
        const minscript = document.createElement("script");
        minscript.async = true;
        minscript.src = publicUrl + "assets/js/main.js";

        document.body.appendChild(minscript);
    }

    onChange = e => this.setState({[e.target.name]: e.target.value} ,(e)=>{
       if (this.state.name.length>0 || this.state.email.length>0){
           this.setState({errors:{}})

       }

    });
    onChangeEmail = e => this.setState({[e.target.name]: e.target.value.trim()},()=>{
        if (this.state.name.length>0 || this.state.email.length>0){
            this.setState({errors:{}})

        }
    });

    handleSubscribeValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        const strchek = /^[A-Z a-z]+$/;
        const validEmailRegex = RegExp(
            /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
        );

        if (!fields.name.trim()) {

            formIsValid = false;
            errors.name = "Full Name must be Required!";
        }
        else if (!fields.name.match(strchek)) {
            formIsValid = false;
            errors.name = "Name in String must be Required!";
        }
        if (!fields.email) {

            formIsValid = false;
            errors.email = "Email must be Required!";
        } else if (!validEmailRegex.test(fields.email)) {
            formIsValid = false;
            errors.email = "Email must be  be  Valid!";
        }

        this.setState({errors: errors});
        return formIsValid;
    };
    onSubscribeFormSubmit = e => {
        e.preventDefault();
        if (this.handleSubscribeValidation()) {
            const {name, email} = this.state;
            const subscribeFormRequest = {
                name,
                email,
            };

            this.props.actionSubscribeForm(subscribeFormRequest);
            this.setState({
                name: '',
                email: '',
                errors: {}
            });

        }
    };

    render() {
 const {errors} =this.state;
 const {subscribeFromLoading} =this.props.auth;

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imgattr = "Footer logo"
        const inlineStyle = {
            backgroundImage: 'url('+publicUrl+footerdata.footerbg+')'
        }

        return (
             <footer className="footer-area">
              <div className="container">
                <div className="footer-top">
                  <div className="row">
                    <div className="col-sm-4">
                      <Link className="footer-logo" to="/"><img src={ publicUrl+footerdata.footerlogo } alt={ imgattr } /></Link>
                    </div>
                    <div className="col-sm-8">
                      <div className="footer-social text-sm-right">
                        <span>FOLLOW US</span>
                        <ul className="social-icon">
                         { footerdata.socialicon.map( ( item, i )=>
                            <li key={i}>
                              <a href={ item.url } target={'_blank'} ><i className={ item.icon } /></a>
                            </li>
                          ) }
                        </ul>
                      </div>  
                    </div>
                  </div>
                </div>
                <div className="footer-bottom">
                  <div className="row">
                    <div className="col-lg-3 col-sm-6">
                      <div className="widget widget_nav_menu">
                        <h4 className="widget-title">{ footerdata.popularserces.title }</h4>
                        <ul>
                          { footerdata.popularserces.links.map( ( item, i )=>
                              <li className="readeal-top" key={ i }><Link to={ item.url } >{ item.title }</Link></li>
                           ) }
                          
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <div className="widget widget_nav_menu">
                        <h4 className="widget-title">{ footerdata.Homepress.title }</h4>
                        <ul>
                          { footerdata.Homepress.links.map( ( item, i )=>
                             <li className="readeal-top" key={ i }><Link to={ item.url } >{ item.title }</Link></li>
                          ) }
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <div className="widget widget_nav_menu">
                       <h4 className="widget-title">{ footerdata.quicklink.title }</h4>
                        <ul>
                         { footerdata.quicklink.links.map( ( item, i )=>
                              <li className="readeal-top" key={ i }><Link to={ item.url } >{ item.title }</Link></li>
                          ) }
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                      <form className="widget widget-subscribe" method="" onSubmit={this.onSubscribeFormSubmit}>
                        <div className="rld-single-input">
                            <input type="text" placeholder="Full Name" name='name' onChange={this.onChange}
                                   value={this.state.name}
                                   id="rdl-mobbb"
                                   className={classnames({
                                       'is-invalid': errors.name
                                   })}/>
                            {errors.name && <span className='text-danger'>{errors.name}</span>}
                        </div>
                        <div className="rld-single-input">
                            <input type="text" placeholder="Email" name='email'
                                   id="rdl-mobbb"
                                   onChange={this.onChangeEmail} value={this.state.email}
                                   className={classnames({
                                       'is-invalid': errors.email
                                   })}/>
                            {errors.email && <span className='text-danger'>{errors.email}</span>}

                        </div>
                          {subscribeFromLoading ?
                              <button
                                  className="btn btn-yellow"
                                  type="button">
                                  <img src={btnLoader} alt="login-loader"
                                       width={15}/>
                              </button> :
                              <button
                                  className="btn btn-yellow"
                                  type="submit">Subscribe
                              </button>}
                      </form>
                    </div>
                  </div>
                </div>
                <div className="copy-right text-center" dangerouslySetInnerHTML={{__html: footerdata.copyrighttext}}>

                </div>
              </div>
            </footer>

        )
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    };
};

export default connect(mapStateToProps, {actionSubscribeForm})(Footer_v1);



